import React, { useMemo } from "react";
import "../css/BoardingServicesCard.css"; // Reuse existing CSS file

const BoardingServiceCard = ({ data = [] }) => {
  const boardingData = useMemo(
    () => data.find((item) => item.service === "Boarding"),
    [data]
  );

  const totalServices = boardingData?.overall_boarding_services || 0;
  const totalRevenue = boardingData?.overall_boarding_services_revenue || 0;
  const ongoingCount = boardingData?.ongoing_services || 0;
  const pendingCount = boardingData?.pending_services || 0;
  const completedCount = boardingData?.completed_service || 0;
  const bestPartner = boardingData?.best_boarding_partner || "—";

  return (
    <div className="boarding-service-card">
      <div className="boarding-service-title">Boarding</div>
      <div className="boarding-service-content">
        <div className="boarding-service-row">
          <span className="boarding-service-label">Overall Boarding Services</span>
          <span className="boarding-service-colon">:</span>
          <span className="boarding-service-value">{totalServices}</span>
        </div>
        <div className="boarding-service-row">
          <span className="boarding-service-label">Overall Boarding Revenue</span>
          <span className="boarding-service-colon">:</span>
          <span className="boarding-service-value">₹{totalRevenue.toLocaleString()}</span>
        </div>
        <div className="boarding-service-row">
          <span className="boarding-service-label">Ongoing Services</span>
          <span className="boarding-service-colon">:</span>
          <span className="boarding-service-value">{ongoingCount}</span>
        </div>
        <div className="boarding-service-row">
          <span className="boarding-service-label">Pending Services</span>
          <span className="boarding-service-colon">:</span>
          <span className="boarding-service-value">{pendingCount}</span>
        </div>
        <div className="boarding-service-row">
          <span className="boarding-service-label">Completed Services</span>
          <span className="boarding-service-colon">:</span>
          <span className="boarding-service-value">{completedCount}</span>
        </div>
        <div className="boarding-service-row">
          <span className="boarding-service-label">Best Boarding Partner</span>
          <span className="boarding-service-colon">:</span>
          <span className="boarding-service-value">{bestPartner}</span>
        </div>
      </div>
    </div>
  );
};

export default BoardingServiceCard;
